<template>
  <div class="main-screen" v-if="urlPath == 'blog'">
    <main class="blog" :class="{ 'blog--reading': this.post }">
      <blog-feed :filters="filters"/>
    </main>
  </div>
  <div class="main-screen" v-else>
    <Header/>
    <main class="blog" :class="{ 'blog--reading': this.post }">
      <blog-nav :content="content" :filters="filters" :navs="navs"/>
      <blog-feed :filters="filters"/>
      <blog-post :post="post"/>
    </main>
    <Footer/>
  </div>
</template>

<style lang="scss">
    @import '../sass/app';
    .blog{
      font-family: Prompt, Helvetica, Arial, sans-serif !important;
      font-weight: 300;
    }
</style>

<script>
import BlogFeed from './BlogFeed'
import BlogPost from './BlogPost'
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import BlogNav from './BlogNav';

export default {
  name: 'blog',
  components: { BlogFeed, BlogPost, Header, Footer, BlogNav},
  resource: 'Blog',
  props: {
    post: String,
    author: String
  },

  data() {
    return {
      urlPath: null,
      navs: 0,
      title: '',
      labels: {
        post: '',
        author: ''
      }
    }
  },
  mounted() {
    this.urlPath = this.$route.path.replace("/", "");
  },
  computed: {
    content() {
      return { title: this.title, labels: this.labels }
    },
    filters() {
      let filters = {}

      if (this.post) filters.post = this.post
      if (this.author) filters.author = this.author

      return filters
    }
  },

  watch: {
    '$route.name' (to, from) {
      if (to !== from) this.navs++
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Blog.vue